import {
  Medication
} from 'one-state-medication/src/medication';

export const sortFunction = (a: Medication, b: Medication) => {
  const dateA = new Date(a.startdate);
  const dateB =new Date(b.startdate);
  return dateB.getTime() - dateA.getTime();
}


/**
* This Function transforms the backend response
* in the Data Model that supports the
* Medication Component
* @param response has the backend
* pcp response
* @param context has settings etc..
*/


export const TransformResponse = (response: any, context: any) => {
  /**
   * @param result contains the transformed response
   */
  // let result: Medication[] = [];
  let result :any = {
      medication:[],
      error:undefined
  }

  const { log,settings } = context;
  const {uisettings:{dateformat}} = settings
  if (response && (response.status >= 400 || response.type == "error")) {
      result.error=response;
   }

  if (response && response.length > 0) {
      const rs = response;
      let medicationarray:Medication[] = [];
      rs.map((ele: any) => {
          function formatDateTimeWithAMPM(dateTimeStr:any) {
              // Parse the string into a Date object
              const dateTime = new Date(dateTimeStr);

              // Extract date components
              const month = dateTime.getMonth() + 1;
              const day = dateTime.getDate();
              const year = dateTime.getFullYear();

              // Extract time components
              const hours = dateTime.getHours();
              const minutes = dateTime.getMinutes();
              const seconds = dateTime.getSeconds();
          
              // Determine AM/PM
              const amPM = hours >= 12 ? 'PM' : 'AM';
              const displayHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour clock
          
              // Format the date and time with AM/PM indication
              const formattedTime = `${displayHours}:${minutes}:${seconds} ${amPM}`;
              const formattedDate = `${month}-${day}-${year}`;

              return [formattedDate,formattedTime]
          }
                  let medicationobj : Medication ={
                      name :"",
                      patientsig:"",
                      startdate:"",
                      enddate:"",
                      refillsremaining:""
                  }
                  medicationobj.name = ele.Name ? ele.Name:"";
                  medicationobj.patientsig =ele.PatientSig ? ele.PatientSig:"";
                  medicationobj.startdate = ele.StartDate ? formatDateTimeWithAMPM(ele.StartDate)[0]:"";
                  medicationobj.enddate = ele.EndDate ? formatDateTimeWithAMPM(ele.EndDate)[0]:"";
                  medicationobj.refillsremaining = ele.RefillsRemaining ? ele.RefillsRemaining:"";
                  medicationarray.push(medicationobj);
      });
      result.medication = medicationarray;
  }
  log.debug(
      "ccw-gadget,medication-epic",
      "medication-epic transforamtion response ", {
      result
  });
  result.medication.sort(sortFunction);
  return result;
}